import React from 'react';
import { motion, AnimatePresence } from 'motion/react';
import { Info, Zap, ShieldAlert } from 'lucide-react';
import { cn } from '../lib/utils';
import { useGameBoard } from './GameBoardContext';

export const RulesPanel: React.FC = () => {
  const { showRules, onToggleRules } = useGameBoard();

  return (
    <div className="fixed top-2 right-2 z-30 flex gap-3">
      <div className="relative">
        <button
          onClick={onToggleRules}
          className={cn(
            "w-11 h-11 rounded-xl border border-white/10 flex items-center justify-center transition-all shadow-lg",
            showRules ? "bg-yellow-500 text-black" : "bg-black/60 text-yellow-500 hover:bg-black/80"
          )}
        >
          <Info className="w-5 h-5" />
        </button>

        <AnimatePresence>
          {showRules && (
            <motion.div
              initial={{ opacity: 0, scale: 0.9, y: -10 }}
              animate={{ opacity: 1, scale: 1, y: 0 }}
              exit={{ opacity: 0, scale: 0.9, y: -10 }}
              className="absolute top-full right-0 mt-3 w-64 glass-panel p-5 rounded-3xl shadow-2xl"
            >
              <span className="text-yellow-500 font-black tracking-widest uppercase text-[11px] mb-4 block border-b border-yellow-500/20 pb-2">Regole Speciali</span>
              <div className="space-y-3">
                <div className="flex items-center gap-3 text-white/80 text-[11px]">
                  <div className="w-6 h-6 rounded bg-yellow-500/20 flex items-center justify-center"><Zap className="w-3.5 h-3.5 text-yellow-500" /></div>
                  <span>Scopa: <b>+1</b> (tavolo vuoto)</span>
                </div>
                <div className="flex items-center gap-3 text-white/80 text-[11px]">
                  <div className="w-6 h-6 rounded bg-yellow-500/20 flex items-center justify-center"><Zap className="w-3.5 h-3.5 text-yellow-500" /></div>
                  <span>Mano ≤ 8: <b>+3</b></span>
                </div>
                <div className="flex items-center gap-3 text-white/80 text-[11px]">
                  <div className="w-6 h-6 rounded bg-purple-500/20 flex items-center justify-center"><Zap className="w-3.5 h-3.5 text-purple-500" /></div>
                  <span>Tre Assi: <b>+6</b></span>
                </div>
                <div className="flex items-center gap-3 text-white/80 text-[11px]">
                  <div className="w-6 h-6 rounded bg-yellow-500/20 flex items-center justify-center"><Zap className="w-3.5 h-3.5 text-yellow-500" /></div>
                  <span>Re (10) Denari: <b>+1</b></span>
                </div>
                <div className="flex items-center gap-3 text-white/80 text-[11px]">
                  <div className="w-6 h-6 rounded bg-red-500/20 flex items-center justify-center"><ShieldAlert className="w-3.5 h-3.5 text-red-500" /></div>
                  <span>2 Denari: <b>-5</b></span>
                </div>
                <div className="flex items-center gap-3 text-white/80 text-[11px]">
                  <div className="w-6 h-6 rounded bg-red-500/20 flex items-center justify-center"><ShieldAlert className="w-3.5 h-3.5 text-red-500" /></div>
                  <span>Zero Denari: <b>-10</b></span>
                </div>
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </div>
  );
};
